import React from 'react';

const useCustomPageCatalog = () => {

  const getCatalogs = (companyContractDisplayId: string, pageBlock: any) => {
    if (pageBlock && Array.isArray(pageBlock.pageBlockItems)) {
      return pageBlock.pageBlockItems.map((pageBlockItem, i) => {
        return {
          title: pageBlockItem.itemName,
          subtitle: pageBlockItem.extendProperties.documentSubName,
          description: pageBlockItem.itemDescription,
          companyName: pageBlockItem.extendProperties.itemCompanyName,
          companyLogoUrl: pageBlockItem.extendProperties.itemCompanyLogoUrl,
          companyPageUrl: pageBlockItem.extendProperties.itemCompanyUrl,
          tags: [pageBlockItem.itemCategoryName],
          catalogImageUrl: pageBlockItem.itemImageUrl,
          catalogPageUrl: pageBlockItem.itemUrl,
          catalogPreviewImageUrls: Array.isArray(pageBlockItem.extendProperties.itemPreviewImageUrls)?pageBlockItem.extendProperties.itemPreviewImageUrls.slice(0, 3):undefined,
          companyContractDisplayId: companyContractDisplayId,
          companyId: pageBlockItem.extendProperties.cluezCompanyId,
          catalogId: pageBlockItem.extendProperties.cluezCatalogId,
          fileSize: pageBlockItem.extendProperties.documentSizeBytes,
        };
      });
    } else {
      return [];
    }
  };

  return {
    getCatalogs,
  }

};

export default useCustomPageCatalog;
